module.exports = __webpack_public_path__ + "static/Clipboard-64252b86fef8e657d088cfd3c3aeda75.png";